import React, { useState } from "react";
import { Title } from "../../../../stories/Title/Title";
import Close from "../../../../images/Close.svg";
import { Button } from "../../../../stories/Button/Button";
import { LabelProps } from "../../../../utils/types";
import {
  FormAutocomplete,
  formClasses
} from "../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../utils/Enum.keys";
import {
  CustomModal,
  handleMUISelectEvent
} from "../../../../utils/UtilFunctions";
import { TextField } from "@mui/material";
import DataFetch from "../../../../images/OpenIcon.svg";
import Items from "../masters/items/Index";
import { AddModalStyles } from "../../../../styles/CustomModalStyles";
import { PageFor } from "../../../../utils/Enum.types";
import Input from "../../../../stories/Input/Input";
import { Label } from "../../../../stories/Label/Label";
import useLabels from "../../../../customHooks/useLabels";
import useFormJson from "../../../../json/useFormJson";


interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
const PurchaseItem = ({ setModalFlag }: Props) => {
  const [itemDetails, setItemDetails] = useState(false);
const {itemLabel}=useLabels();
const {Purchase}=useFormJson();
  return (
    <>
      <div className="purchase__item">
        <div className="purchase__item__title">
          <Title> Add {itemLabel} Details</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        {/* use this div for form */}
        <div className="purchase__item__form">
          <div className="purchase__item__form--details">
          {Purchase.AddItem.map((label: LabelProps, index: React.Key) => {
  if (label.inputName === "item_code") {
    return (
     
        <div className="purchase__item__form--details--grid">
        <Label>{label.labelName}</Label>
          <FormAutocomplete
            className={formClasses.inputRoot}
            options={["CCTV Camera"]}
            onKeyDown={(e) => {
              if (e.key === Keys.ENTER) {
                e.preventDefault();
                handleMUISelectEvent(e);
              }
            }}
            openOnFocus
            forcePopupIcon
            freeSolo
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                className={formClasses.formControlRoot}
              />
            )}
          />
             <img
          src={DataFetch}
          alt="Fetch Data"
          className="data-fetch-icon"
          onClick={() => setItemDetails(!itemDetails)}
        />
        </div>
     
     
    );
  }

  // For other cases
  return (
    <div key={index} className="label-grid">
      <Label>{label.labelName}</Label>
      <Input disabled={label.disabled} />
    </div>
  );
})}

          </div>
          <Button mode="save" />
          <Button mode="cancel" onClick={() => setModalFlag(false)} />
        </div>
      </div>
      <CustomModal
        isOpen={itemDetails}
        onRequestClose={() => setItemDetails(!itemDetails)}
        contentComponent={
          <Items pageType={PageFor.MODAL} setModalFlag={setItemDetails} />
        }
        style={AddModalStyles}
      />
    </>
  );
};

export default PurchaseItem;
